// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__cbJ7D","left":"Virtual_left__p6EPB","wrapper":"Virtual_wrapper__NOShh"};